import { ColumnSetting } from '../../../_foundation/models/grid.models';

export const columns: ColumnSetting[] = [
  {
    field: 'displayTime',
    title: 'Time',
    filter: 'text',
    width: 50,
    minWidth: 50
  },
  {
    field: 'locationText',
    title: 'Location',
    filter: 'text',
    width: 140
  },
  {
    field: 'operationName',
    title: 'Operation',
    filter: 'text',
    width: 140
  },
  {
    field: 'stageName',
    title: 'Stage',
    filter: 'text',
    width: 160
  },
  {
    field: 'statusText',
    title: 'Status',
    filter: 'text',
    width: 50
  },
  {
    field: 'logDetailText',
    title: 'Log Detail',
    filter: 'text',
    width: 210
  }
];



// WEBPACK FOOTER //
// ./src/pages/daily-progress-report/daily-progress-report-preview/daily-progress-report-preview.config.ts